/*

func FormatFileSize(size int64) string {
	base := math.Log(float64(size)) / math.Log(1024)
	prefix := round(math.Pow(1024, base-math.Floor(base)), 2)
	var suffix string
	switch int(math.Floor(base)) {
	case 0:
		suffix = "o"
	case 1:
		suffix = "Ko"
	case 2:
		suffix = "Mo"
	case 3:
		suffix = "Go"
	case 4:
		suffix = "To"
	default:
		panic(fmt.Errorf("Too big"))
	}
	return fmt.Sprintf("%.2f%s", prefix, suffix)
}


*/

export function formatFileSize(size: number): string {
	const base = Math.log(size) / Math.log(1024)
	const prefix = 1024 ** (base - Math.floor(base));
	let suffix = "";
	switch (Math.floor(base)) {
		case 0:
			suffix = "o";
			break;
		case 1:
			suffix = "Ko"
			break;
		case 2:
			suffix = "Mo"
			break;
		case 3:
			suffix = "Go"
			break;
		case 4:
			suffix = "To"
			break;
		default:
			throw new Error("Too big");
	}
	return `${prefix.toFixed(2)}${suffix}`
}